"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const healthBannerInputs = [
  {
    name: "content",
    type: "richText",
    required: true,
    defaultValue: "18+. THESE PRODUCTS ARE NOT RISK-FREE AND ARE ADDICTIVE",
  },
  {
    name: "variant",
    type: "string",
    enum: ["default", "strong", "stronger"],
    required: true,
    defaultValue: "strong",
  },
] as const satisfies Inputs;

const HealthBanner = dynamic(async () =>
  withValidation(
    healthBannerInputs,
    (await import("./HealthBanner")).HealthBanner,
    "HealthBanner"
  )
);

export const HealthBannerComponent: RegisteredComponent = {
  name: "HealthBanner",
  component: HealthBanner,
  inputs: healthBannerInputs,
};
